import HotelEntity from '../Entity/Hotel';
import buildHotelData from './service/buildHotelData';

export default (data) => {
    const hotel = buildHotelData(data);
    return new HotelEntity(hotel);
};